import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import outSideClick from 'directives/outSideClick';
import { sendItemToAnalytics } from 'common/utils/sendAnalyticsEvent';

import CreateWishlistItem from '../../graphql/mutations/CreateWishlistItemMutation.graphql';
import DeleteWishlistItem from '../../graphql/mutations/DeleteWishlistItemMutation.graphql';
import UserWishlistItems from '../../graphql/queries/UserWishlistItems.graphql';

Vue.directive('outSideClick', outSideClick);

@Component({
  directives: {
    clickOutside: outSideClick.directive,
  },
  apollo: {
    wishitems: UserWishlistItems,
  },
  props: {
    product: {
      type: Object,
    },
    emptyHeartColor: {
      type: String,
      default: '--black',
    },
    tooltipTopPosition: {
      type: String,
      default: '40',
    },
    withBackground: {
      type: Boolean,
      default: false,
    },
  },
  /*
   * default value for apollo queries
   */
  data() {
    return {
      wishItems: [],
    };
  },
})
export default class HeartItComponent extends Vue {
  displayTooltip = false;

  /**
   * Open/close the whislist options tooltip.
   */
  toggleTooltip() {
    this.displayTooltip = !this.displayTooltip;
  }

  onClickOutside() {
    this.displayTooltip = false;
  }

  /**
   * Fill the heart in the box.
   * @returns {boolean} cant be null.
   */
  get hearted() {
    if (!this.wishitems) {
      return false;
    }
    const wish = this.wishitems.find(item => this.wish(item));
    return Boolean(wish);
  }

  /**
   * Find the product in the wish object.
   * @param wish {object} poroduct_id, to_who, id
   * @returns {boolean}
   */
  wish(item, toWho) {
    return toWho
      ? item.product_id === this.product.id && item.to_who === toWho
      : item.product_id === this.product.id;
  }

  /**
   * Mutation to store the wish, in case the wish exist it's going to delete.
   * @param toWho_ for who is the wish, options are for_me/for_gift
   */
  async updateWish(toWho_) {
    const wish = this.wishitems.filter(item =>
      this.wish(item, toWho_.toUpperCase()),
    );
    const exist = Boolean(wish.length);

    const response = await this.$apollo.mutate({
      mutation: exist ? DeleteWishlistItem : CreateWishlistItem,
      variables: {
        toWho: toWho_,
        productId: this.product.id,
      },
    });
    const { ok } = response.data.updateWishItem;
    const user = Boolean(
      response.data.updateWishItem.errors &&
        response.data.updateWishItem.errors.user,
    );
    if (user) {
      this.$router.push({
        name: 'login',
      });
    } else if (ok) {
      if (!exist) this.sendAnalytics(toWho_, this.product);
      this.$apollo.queries.wishitems.refetch();
    }
  }

  sendAnalytics(toWho_, product) {
    //TODO:: Find the way to send user's email to analytics
    sendItemToAnalytics(`add_to_wishlist_${toWho_}`, [product]);
  }

  /**
   * Watcher for property wisitems to change 'wish for me' and 'wish for gift'.
   */
  @Watch('wishitems')
  onWishItemsChange() {
    const forGift = this.wishitems.filter(item => this.wish(item, 'FOR_GIFT'));
    const forMe = this.wishitems.filter(item => this.wish(item, 'FOR_ME'));
    this.product.forGift = Boolean(forGift.length);
    this.product.forMe = Boolean(forMe.length);
  }
}
